export enum XpressCalendarEnum {
    Today = 'Today',
    Yesterday = 'Yesterday',
    Last7Days = 'Last 7 days',
    Last30Days = 'Last 30 days',
    ThisMonth = 'This Month',
    Custom = 'Custom'
}
